<div class="container-fluid">
  <page-header-search
    [isSearchInput]="true"
    [pageTitleValue]="pageTitle"
    [placeholderValue]="placeholder"
    (onHeaderInputKeyup)="onSearchInputKeyup($event)"
    (onHeaderSearchSubmit)="onSearchService($event)"
  ></page-header-search>

  <div *ngIf="filteredLatestServicesArray.length" class="card">
    <div class="card-body">
      <div class="table-title">
        <h3 class="title mb-0">All Latest Services</h3>
        <!-- <a (click)="invertSorting()">
          <span>↑</span>
          <span class="ml--1">↓</span>
          Sort By
        </a> -->
      </div>
      <div class="table-responsive">
        <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th
                class="sort"
                data-sort="enName"
                scope="col"
                sortable="enName"
                (sort)="onSort($event)"
              >
                {{ "Service EN Name" | uppercase }}
              </th>
              <th
                class="sort"
                data-sort="arName"
                scope="col"
                sortable="arName"
                (sort)="onSort($event)"
              >
                {{ "Service AR Name" | uppercase }}
              </th>
              <th
                class="sort"
                data-sort="rank"
                scope="col"
                sortable="rank"
                (sort)="onSort($event)"
              >
                {{ "Service Rank" | uppercase }}
              </th>
              <th
                class="sort"
                data-sort="routeName"
                scope="col"
                sortable="routeName"
                (sort)="onSort($event)"
              >
                {{ "Service Route" | uppercase }}
              </th>
              <th
                class="sort"
                data-sort="typeId"
                scope="col"
                sortable="typeId"
                (sort)="onSort($event)"
              >
                {{ "Se7etak Service" | uppercase }}
              </th>
              <th
                class="sort"
                data-sort="statusId"
                scope="col"
                sortable="statusId"
                (sort)="onSort($event)"
              >
                {{ "Latest Service" | uppercase }}
              </th>
              <th>
                {{ "Service Actions" | uppercase }}
              </th>
              <!-- <th *ngFor="let th of theadArray">{{ th | uppercase }}</th> -->
            </tr>
          </thead>
          <tbody>
            <tr
              class="pointer"
              *ngFor="let item of filteredLatestServicesArray"
            >
              <td>
                <span>{{ item.enName }}</span>
              </td>
              <td>
                <span>{{ item.arName }}</span>
              </td>
              <td>
                <span>{{ item.rank }}</span>
              </td>
              <td>
                <span>{{ item.routeName }}</span>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <label class="custom-toggle custom-toggle-default">
                    <input
                      [checked]="
                        item.typeId == 1
                          ? true
                          : item.typeId == 2
                          ? false
                          : item.typeId
                      "
                      type="checkbox"
                      id="active-check"
                      (change)="onSehetakServiceChange($event, item)"
                    />
                    <span
                      class="custom-toggle-slider rounded-circle"
                      data-label-off="No"
                      data-label-on="Yes"
                    >
                    </span>
                  </label>
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <label class="custom-toggle custom-toggle-default">
                    <input
                      [checked]="
                        item.statusId == 1
                          ? true
                          : item.statusId == 2
                          ? false
                          : item.statusId
                      "
                      type="checkbox"
                      id="active-check"
                      (change)="onLatestServiceChange($event, item)"
                    />
                    <span
                      class="custom-toggle-slider rounded-circle"
                      data-label-off="No"
                      data-label-on="Yes"
                    >
                    </span>
                  </label>
                </div>
              </td>
              <td>
                <button
                  class="btn btn-icon btn-outline-success mr-2"
                  type="button"
                  placement="top"
                  tooltip="Edit"
                  [routerLink]="['edit', item.id]"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"> </i>
                  </span>
                </button>
                <button
                  class="btn btn-icon btn-outline-warning mr-2"
                  type="button"
                  placement="top"
                  tooltip="Delete"
                  (click)="onDeleteService($event, item)"
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-trash"> </i>
                  </span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="fab-btn" [routerLink]="'add'">
  <i class="ni ni-fat-add"></i>
</div>
